/// <amd-module name="WorkItemsHub/Components/Cells/WorkItemSimpleCell" />
import * as TooltipEx from "VSSUI/TooltipEx";
import * as React from "react";

export interface ISimpleCellOptions {
    text: string;
}

export function createWorkItemSimpleCell(options: ISimpleCellOptions): JSX.Element {
    return (
        <TooltipEx.Tooltip text={options.text} overflowOnly={true}>
            <span className="work-item-simple-cell">{options.text}</span>
        </TooltipEx.Tooltip>
    );
}
